import React from 'react';
import { motion } from 'framer-motion';

const InfoCard = ({ icon, title, children, theme = 'dark' }) => {
  // Define styles based on the theme prop
  const themeStyles = {
    dark: {
      cardBg: "bg-white/5",
      border: "border-white/10",
      iconBg: "bg-indigo-900/50",
      iconColor: "text-indigo-300",
      titleColor: "text-white",
      textColor: "text-white/70",
    },
    light: {
      cardBg: "bg-white",
      border: "border-gray-200 shadow-lg",
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      titleColor: "text-gray-900",
      textColor: "text-gray-600",
    }
  };

  const currentTheme = themeStyles[theme];

  return (
    <motion.div
      className={`p-8 rounded-2xl ${currentTheme.cardBg} ${currentTheme.border}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.5 }}
    >
      <div className={`h-16 w-16 rounded-full flex items-center justify-center mb-6 ${currentTheme.iconBg}`}>
        <div className={currentTheme.iconColor}>{icon}</div>
      </div>
      <h3 className={`syne-font text-2xl font-bold mb-4 ${currentTheme.titleColor}`}>{title}</h3>
      <p className={`leading-relaxed ${currentTheme.textColor}`}>{children}</p>
    </motion.div>
  );
};

export default InfoCard;